import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './DLAs.css';

const DLAs = () => {
  const dlas = [
    {
      name: 'SnapPaisa',
      url: 'https://www.snappaisa.com/',
      logo: '/dlas/snappaisa.png'
    },
    {
      name: 'FastPaise',
      url: 'https://fastpaise.ai/',
      logo: '/dlas/fastpaise.png'
    },
    {
      name: 'F1 Speed Loan',
      url: 'https://f1speedloan.com/',
      logo: '/dlas/f1speedloan.png'
    },
    {
      name: 'Salaryadda',
      url: 'https://salaryadda.com/',
      logo: '/dlas/salaryadda.png'
    },
    {
      name: 'Salarysetu',
      url: 'https://salarysetu.com/',
      logo: '/dlas/salarysetu.png'
    },
    {
      name: 'CredBuddy',
      url: 'https://thecredbuddy.com/apply/pan-mobile',
      logo: '/dlas/credbuddy.png'
    }
  ];

  const formatUrl = (url) => {
    const domain = url
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '')
      .replace(/\/.*$/, '');
    return `www.${domain}`;
  };

  const handleLogoError = (e, name) => {
    e.target.style.display = 'none';
    const fallback = e.target.nextElementSibling;
    if (fallback) {
      fallback.style.display = 'flex';
    }
  };

  return (
    <div className="dlas-page">
      {/* Banner Section */}
      <section className="dlas-banner">
        <div className="dlas-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">DLAS</h2>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="dlas-content">
        <div className="dlas-wrapper">
          <div className="dlas-list">
            {dlas.map((dla, index) => (
              <a
                key={index}
                href={dla.url}
                target="_blank"
                rel="noopener noreferrer"
                className="dla-item"
              >
                <div className="dla-logo">
                  <img
                    src={dla.logo}
                    alt={dla.name}
                    onError={(e) => handleLogoError(e, dla.name)}
                  />
                  <span className="dla-logo-fallback">{dla.name.charAt(0)}</span>
                </div>
                <div className="dla-info">
                  <div className="dla-name">{dla.name}</div>
                  <div className="dla-url">{formatUrl(dla.url)}</div>
                </div>
                <div className="dla-arrow">↗</div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DLAs;
